import * as workOrderActions from 'actions/workOrderActions';
import * as statusActions from 'actions/statusActions';
import moment from 'moment';
import { getOidc, getUser } from 'utils/userManager';

let monitoringInterval = null;

export const checkForExpiredItems = (store, config) => {
    const state = store.getState();
    const techs = state.getIn(['techData', 'techs']);
    const thisTechsUserId = state.getIn(['user', 'userId']);

    techs.forEach((tech) => {
        const userId = tech.getIn(['info', 'userId']);
        if (userId) {
            const routeExpires = moment(tech.get('routeLoadedTime')).add(config.techRouteExpireMinutes, 'minutes');

            const statusExpires = moment(tech.get('statusLoadedTime')).add(config.techStatusExpireMinutes, 'minutes');

            const routeExpired = moment().isAfter(routeExpires);
            const statusExpired = moment().isAfter(statusExpires);

            //check for stuff that has been marked as loading for longer than expected.

            if (moment(tech.get('routeLoadedTime')).add(2, 'minutes').isBefore(moment()) && tech.get('workOrderLoading')) {
                store.dispatch(workOrderActions.workOrderGetTechRouteFailed({}, userId));
            }

            // A status change is normally confirmed by a PubNub "TechStatusUpdate" push (see
            // pubnubMiddleware.js). If that confirmation never arrives (dropped subscription,
            // connectivity blip, etc.) statusLoading/statusWaiting are left stuck true forever,
            // which hides the ArrivalTimeDialog submit button and blocks all further status
            // changes. Force-fail it after a timeout so the tech can retry.
            const statusLoadingStartedTime = tech.get('statusLoadingStartedTime');

            if (
                statusLoadingStartedTime &&
                (tech.get('statusLoading') || tech.get('statusWaiting')) &&
                moment(statusLoadingStartedTime).add(config.techStatusChangeTimeoutSeconds, 'seconds').isBefore(moment())
            ) {
                store.dispatch(statusActions.setTechStatusFailed({}, userId));
            }

            // check expired items and start loading them if they are expired.
            if (routeExpired && !tech.get('workOrderLoading')) {
                store.dispatch(workOrderActions.workOrderGetTechRouteStarted({
                    userId: userId,
                    isSelf: thisTechsUserId === userId
                }));
            }

            if (statusExpired && !tech.get('statusLoading') && !tech.get('statusWaiting')) {
                const channels = [userId];
                if (userId && thisTechsUserId && userId !== thisTechsUserId) {
                    channels.push(thisTechsUserId);
                }
                store.dispatch(statusActions.getTechStatusStarted({
                    techStatusChange: {
                        userId: userId,
                        techStatusWorkOrder: {
                            workOrderNumber: null,
                            arrivalTime: null,
                            serviceType: ""
                        },
                        techStatus: "GetStatus"
                    },
                    channels: channels
                }, userId));
            }
        }
    });

    //clear out work order that are more than 24 hours old.
    const workOrderDetails = state.getIn(['workOrder', 'workOrderDetails']);

    if (workOrderDetails) {

        workOrderDetails.forEach((workOrderDetail) => {

            const detailExpires = moment(workOrderDetail.get('lastUpdated')).add(24, 'hours');
            const orderId = workOrderDetail.getIn(['schedulingSystemDetails', 'details', 'serviceOrderInfoV2', 'serviceOrderId']);

            if (moment().isAfter(detailExpires) && orderId) {
                store.dispatch(workOrderActions.clearWorkOrderDetail(orderId));
            }

        });
    }
};

const middlewareHandler = (store, next, action, config) => {

    next(action);

    const state = store.getState();

    const userId = state
        .getIn(['user', 'userId']);

    const oidcUser = getUser(getOidc(state));

    if (!monitoringInterval && userId && oidcUser) {
        monitoringInterval = setInterval(() => {
            checkForExpiredItems(store, config);

        }, 10000);
    }

    if (action.type === 'redux-oidc/SESSION_TERMINATED') {
        clearInterval(monitoringInterval);
    }

};

export default middlewareHandler;

export const createMonitoringMiddleware = (config) => {

    return (store) => (next) => (action) => {
        middlewareHandler(store, next, action, config);
    };
};



// WEBPACK FOOTER //
// ./src/store/monitoringMiddleware.js